import { useLocation } from "react-router-dom";
import { pipe, prop, split } from "ramda";

export const useEntityId = () => {
  const location = useLocation();
  return pipe(prop("pathname"), split("/"), (arr) => arr[2])(location);
};
